// extracted by mini-css-extract-plugin
module.exports = {"version":"AboutDialog_version__2CXBy","contentArea":"AboutDialog_contentArea__2j_u2"};